module.exports = (__webpack_require__("dll-reference pcxbase"))("./core/api/wxApi.js");